export default "__VITE_ASSET__CIeGesMi__"